<template>
	<div class="class-page topic-detail-page">
			<!-- Header -->
			<class-page-header :details="details" :current-section="parseInt(sectionId)" :course="course" :menu="menu" :is-class-item-page="true"></class-page-header>


			<h2>{{forum.TITLE}}</h2>
			<p> {{ $t('MAIN_CONTENT.Post.forumLoadedAt', { date: pageLoadedDate } ) }}</p>
			<!-- Comment message -->
			<div class="grey-border topic-box">
					<div class="row">
						<img :src="currentTopic.POSTER_PHOTO_URL"
								 class="img-responsive rounded cp-student-photo-image-circle col-xs-3 col-md-2"
								 alt="Photo"
								 v-if="currentTopic.POSTER_PHOTO_URL"/>
						<img src="/CommunityWebPortal/_app/includes/static/images/profiles/no-staff-image.png"
								 class="img-responsive cp-student-photo-image-circle col-xs-3 col-md-2"
								 alt="Photo"
								 v-else />
						<div class="col-md-10">
							<strong>
								<p>{{ currentTopic.USER_NAME }}</p>
								<span class="text-primary" v-html="currentTopic.SUBJECT !== undefined && currentTopic.SUBJECT ? post.SUBJECT : `${ currentTopic.TITLE }`"></span>
							</strong>
						</div>
						<div class="col-md-11">
							<div class="topic-preview" v-html="currentTopic !== null ? currentTopic.MESSAGE : ''"></div>
						</div>
					</div>
					<div class="row actions-topic">
							<div class="col-xs-6 text-left">
								<a href="#" @click.prevent="goToTopics()" class="back-to-topics btn on-grey">
									<strong>
											<font-awesome-icon icon="chevron-left"></font-awesome-icon> {{$t('MAIN_CONTENT.Post.backToTopics')}}
									</strong>
								</a>
							</div>
							<div class="col-xs-6">
								<!-- Comment button -->
								<button type="button" class="btn btn-comment" data-toggle="modal" @click="openNewPostModal">
										<i class="fas fa-comment" aria-hidden="true"></i>
										{{$t('MAIN_CONTENT.Post.comment')}}
								</button>

								<!-- Refresh button -->
								<button type="button" class="btn btn-refresh" @click="fetchTopic(true)">
										<i class="fas fa-redo" aria-hidden="true"></i>
										{{$t('MAIN_CONTENT.Post.refresh')}}
								</button>
							</div>
					</div>
			</div>

			<!-- Posts -->
			<template v-if="currentTopic !== null">
					<template v-for="( post, index ) in displayablePosts">
							<div class="box" :key="`post-${ post.POST_ID }`" :ref="`post_${post.POST_ID}`">
									<div class="comment-box">

											<!-- Header -->
											<div class="comment-header">

													<div class="date-post">
															<small :title="post.CREATED_DATE">{{ humanizeDate( post.CREATED_DATE ) }}</small>
													</div>

													<!-- Information -->
													<div class="row">
															<img :src="post.POSTER_PHOTO_URL"
																	 class="img-responsive rounded cp-student-photo-image-circle col-xs-3 col-md-2"
																	 alt="Photo"
																	 v-if="post.POSTER_PHOTO_URL"/>
															<img src="/CommunityWebPortal/_app/includes/static/images/profiles/no-staff-image.png"
																	 class="img-responsive cp-student-photo-image-circle col-xs-3 col-md-2"
																	 alt="Photo"
																	 v-else />
															<div class="col-md-10">
																	<strong>
																			<p>{{ post.USER_NAME }}</p>
																			<span class="text-primary" v-html="post.SUBJECT !== undefined && post.SUBJECT ? post.SUBJECT : `RE: ${ currentTopic.TITLE }`"></span>
																	</strong>
															</div>
													</div>
											</div>

											<!-- Content -->
											<div class="comment-content">
													<div v-html="post.REPLY"></div>
											</div>

											<!-- Buttons -->
											<div class="actions">
													<button @click="openEditPostModal(post)" class="btn btn-link on-grey" v-if="post.IS_DELETED_FLG !== 'Y' && post.CREATED_BY === selectedStudent.STUDENT_RID">
															<strong>
																	<font-awesome-icon icon="pen"></font-awesome-icon> {{$t('commonText.edit')}}
															</strong>
													</button>
													<button @click="isReplying = post.POST_ID" class="reply-comment btn-link" v-if="post.IS_DELETED_FLG === 'N'"><i class="fa fa-comments on-teal "></i> {{$t('MAIN_CONTENT.Post.reply')}}</button>
											</div>

											<!-- Reply box -->
											<div class="reply-box" v-show="isReplying === post.POST_ID">
													<ckeditor4 v-model="reply.REPLY"
																		 v-if="isReplying === post.POST_ID"
																		 :config="editorConfig"
																		 :simpleImagesDialog="true"
																		 id="reply-message">
													</ckeditor4>
													<div>
															<button class="btn btn-default" @click="isReplying = -1">{{$t('commonText.cancel')}}</button>
															<button class="btn btn-comment" @click="postReply( post )">{{$t('MAIN_CONTENT.commonContent.submit')}}</button>
													</div>

											</div>
									</div>

									<div class="replies">
											<!-- Show count of replies -->
											<div v-show="!isPostRepliesOpen(post.POST_ID) && getPostsCount( post )" :key="`post-replies-count-${ post.POST_ID }`" @click="toggleOpenPostReplies(post.POST_ID)" class="show-replies">
													<!-- <i class="fas fa-long-arrow-alt-down" aria-hidden="true"></i> -->
													<font-awesome-icon icon="long-arrow-alt-down"></font-awesome-icon>
													{{ getPostsCount( post ) > 1 ? $t('MAIN_CONTENT.Post.showNReplies', { count: getPostsCount( post ) }) : $t('MAIN_CONTENT.Post.showOneReply') }}
											</div>
											<!-- Show replies -->
											<div v-show="isPostRepliesOpen(post.POST_ID)" :key="`post-replies-${ post.POST_ID }`">
													<div class="show-replies">
															<span @click="toggleOpenPostReplies(post.POST_ID)">
																	<font-awesome-icon icon="arrows-alt-v"></font-awesome-icon>
																	{{ $t('MAIN_CONTENT.Post.hideReplies') }}
															</span>
													</div>

													<div class="replies-post" v-for="reply in getPostsReplies( post )" :key="`reply-${ reply.POST_ID }`" :ref="`post_${reply.POST_ID}`">
															<div class="row margin-bottom-10">
																	<img :src="reply.POSTER_PHOTO_URL"
																			 class="img-responsive rounded cp-student-photo-image-circle col-xs-3 col-md-2"
																			 alt="Photo"
																			 v-if="reply.POSTER_PHOTO_URL"/>
																	<img src="/CommunityWebPortal/_app/includes/static/images/profiles/no-staff-image.png"
																			 class="img-responsive cp-student-photo-image-circle col-xs-3 col-md-2"
																			 alt="Photo"
																			 v-else />
																	<div class="col-md-10">
																			<div class="date-post">
																					<small :title="reply.CREATED_DATE">{{ humanizeDate( reply.CREATED_DATE ) }}</small>
																			</div>
																			<strong>
																					<p>{{ reply.USER_NAME }}</p>
																					<span class="text-primary" v-html="reply.SUBJECT ? reply.SUBJECT : `RE: ${ post.SUBJECT }`"></span>
																			</strong>
																			<div class="comment-content" v-html="reply.REPLY"></div>
																	</div>
															</div>

															<div class="actions" v-if="reply.IS_DELETED_FLG !== 'Y' && reply.CREATED_BY === selectedStudent.STUDENT_RID">
																<a href="#" @click.prevent="openEditPostModal(reply, post.SUBJECT)" class="btn on-grey">
																		<strong>
																				<font-awesome-icon icon="pen"></font-awesome-icon> {{$t("commonText.edit")}}
																		</strong>
																</a>
															</div>
													</div>
											</div>
									</div>
							</div>
					</template>
			</template>
				<!-- Create Post modal -->
				<modal mode="custom" :modal-title="$t('MAIN_CONTENT.Post.newComment')" :show="showNewPostModal" dialog-size="lg" name="newPostModal" @close="showNewPostModal = false">
					<template>
						<!-- Post -->
						<div class="form-group">
								<label for="title">{{$t('commonText.title')}}</label>
								<input class="form-control" readonly="true" id="title" v-model.trim="reply.SUBJECT" :placeholder="`RE: ${currentTopic.TITLE}`" />
						</div>	
						<div class="form-group reply-area">
								<label for="post">{{$t('MAIN_CONTENT.Post.comment')}}</label>
								<ckeditor4 
									v-model="reply.REPLY" 
									:config="editorConfig"
									:simpleImagesDialog="true"
									id="post"
								>
								</ckeditor4>
						</div>
					</template>
					<template slot="footer">
						<button type="button" class="btn btn-default" @click="showNewPostModal = false">{{ $t('commonText.cancel') }}</button>
						<button type="button" class="btn btn-new" @click="addPost">{{$t('MAIN_CONTENT.commonContent.submit')}}</button>
					</template>
				</modal>
				<!-- Update Post modal -->
				<modal mode="custom" :modal-title="$t('MAIN_CONTENT.Post.editPost')" :show="showEditPostModal" dialog-size="lg" name="editPostModal" @close="closeEditPostModal">
					<template>
						<div class="form-group">
								<label for="title">{{$t('commonText.title')}}</label>
								<input class="form-control" id="title" v-model.trim="reply.SUBJECT" :placeholder="$t('commonText.title')" />
						</div>
						<div class="form-group">
								<label for="message">{{$t("MAIN_CONTENT.Post.comment")}}</label>
								<ckeditor4 
									v-model="reply.REPLY" 
									:config="editorConfig"
									:simpleImagesDialog="true"
									id="message"
								>
								</ckeditor4>
						</div>
					</template>
					<template slot="footer">
						<button type="button" class="btn btn-default" @click="closeEditPostModal">{{ $t('MAIN_CONTENT.commonContent.closeButton') }}</button>
						<button type="button" class="btn btn-new" @click="updatePost()">{{ $t('commonText.save') }}</button>
					</template>
				</modal>
			<class-page-footer :course="course" :menu="menu" :current-section="parseInt(sectionId)" :is-class-item-page="true"/>
	</div>
</template>

<script>
import moment from "moment";
import { mapActions, mapState, mapGetters } from "vuex";

import ClassPageTopicLogResource from '../../api/ClassPageTopicLog';
import ClassPageDetailsResource from '../../api/ClassPageDetails';
import ClassPageMenuResource from '../../api/ClassPageMenu';
import CoursesResource from '../../api/Courses';
import ForumResource from '../../api/ClassPageForum';
import TopicResource from '../../api/ClassPageTopic';
import PostResource from '../../api/ClassPagePost';
import ckeditor4 from '../ckeditor4.vue';

import Modal from 'COMMONS/shared/Modal/Modal.vue';

import ClassPageHeader from "./Header.vue";
import ClassPageFooter from "./Footer.vue";

export default {
	name: "Post",

	data(){
			return {
					id         : parseInt( new URLSearchParams( window.location.search ).get( "id" ) ),
					topic      : {},
					currentTopic: {},
					currentPost: {},
					isReplying : -1,
					openPostReplies: [],
					forum: {},
					menu: [],
					details: {},
					course: {},
					showNewPostModal: false,
					showEditPostModal: false,
					pageLoadedDate: "",
					reply: {
							POST_ID      : null,
							PARENT_ID    : null,
							SUBJECT      : "",
							REPLY        : "",
							USER_NAME    : "",
							CREATED_DATE : "",
							REPLIES      : [],
							isShown      : false
					},
					editorConfig: {
						'language': 'en',
						'uicolor':'#AADC6E',
						'customConfig':'',
						'toolbarCanCollapse': true,
						'toolbarStartupExpanded' : true,
						'enableTabKeyTools':true,
						'forcePasteAsPlainText':false,
						'forcePasteFromWord':true,
						'ignoreEmptyParagraph':true,
						'pasteFromWordPromptCleanup':true,
						'pasteFromWordIgnoreFontFace':true,
						'pasteFromWordKeepsStructure':true,
						'pasteFromWordRemoveFontStyles':true,
						'pasteFromWordRemoveStyles':true,
						'contentsCssStatic':"",
						'removePlugins': { 
							/* set to 1 to remove the plugin, 0 to keep it */
							"forms":1, 
							"print":1,
							"preview":1,
							"about":1,
							"flash":1, 
							"newpage":1,
							"eqneditor":1,
							"justify":1,
							"colorbutton":1,
							"wsc":1,
							"scayt":1,
							"link":1,
							"a11yhelp":1,
							"video":1,
							"tabletools":1,
							"table":1,
							"iframe":1,
							"div":1,
							"sourcearea":1,
							"templates":1,
							"smiley":1,
							"about":1,
							"pagebreak":1,
							"find":1
						},
						'extraPlugins' : {"image":1,"justify":1,"colorbutton":1, "find":1, "font":1},
						'tabSpaces':5,
						'fontSize_sizes':'8/8pt;9/9pt;10/10pt;11/11pt;12/12pt;14/14pt;16/16pt;18/18pt;20/20pt;22/22pt;24/24pt;26/26pt;28/28pt;30/30pt;36/36pt;48/48pt',
						'font_names':
							'Andale Mono/Andale Mono, monospace;'+
							'Arial/Arial, Helvetica, sans-serif;'+
							'Bitstream Vera Sans/Bitstream Vera Sans, Helvetica, sans-serif;' +
							'Bitstream Vera Serif/Bitstream Vera Serif, Times New Roman, serif;' +
							'Comic Sans MS/Comic Sans MS, cursive;' +
							'Courier New/Courier New, Courier, monospace;' +
							'Gentium Basic/Gentium Basic, Times New Roman, serif;' +
							'Gentium Book Basic/Gentium Book Basic, Times New Roman, serif;' +
							'Georgia/Georgia, serif;' +
							'Impact/Impact, serif;' +
							'Liberation Mono/Liberation Mono, Courier New, Courier, monospace;' +
							'Liberation Sans/Liberation Sans, Helvetica, sans-serif;' +
							'Liberation Serif/Liberation Serif, Times New Roman, serif;' +
							'Linux Libertine/Linux Libertine, Helvetica, sans-serif;' +
							'Souvenir Mono ITCTT/Souvenir Mono ITCTT, Courier New, Courier, monospace;' +
							'Synchro LET/Synchro LET, sans-serif;' +
							'Tahoma/Tahoma, Geneva, sans-serif;' +
							'Times New Roman/Times New Roman, Times, serif;' +
							'Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;' +
							'Verdana/Verdana, Geneva, sans-serif'
					}
			}
		},
	components: { 
		ClassPageHeader,
		ClassPageFooter,
		Modal,
		ckeditor4,
	},
	computed: {
		...mapGetters( [ "selectedStudent" ] ),
		sectionId() {
			return this.$route.params.folderId ? this.$route.params.folderId : 0;
		},
		forumType(){
			let type = '';
			if( this.$route.name === 'ClassPageForumPost' ){
				type = 'course';
			} else if( this.$route.name === 'ClassPageSectionForumPost' ){
				type = 'course';
			} else if ( this.$route.name === 'ClassPageGroupForumPost' ) {
				type = 'group';
			} else if ( this.$route.name === 'ClassPageStudentForumPost' ) {
				type = 'student';
			}

			return type;
		},
		displayablePosts(){
			let displayablePosts = [];

			// We want to exclude the first post since it is a duplicate of the topic.
			if( this.currentTopic.POSTS.length > 1 ){
				for( let i = 1; i < this.currentTopic.POSTS.length; i++ ){
					displayablePosts.push(this.currentTopic.POSTS[i]);
				}
			}

			return displayablePosts;
		}
	},

	methods: {
			scrollToPost(postId){
				this.$nextTick(() => {
					const element = this.$refs[`post_${postId}`][0];
					window.scrollTo(0, element.offsetTop);
				});
			},
			goToTopics(){
				let name = '';
				let params = this.$route.params;
				delete params.topicId;

				if( this.$route.name === 'ClassPageForumPost' ){
					name = 'ClassPageForum';
				} else if( this.$route.name === 'ClassPageSectionForumPost' ){
					name = 'ClassPageSectionForum';
				} else if ( this.$route.name === 'ClassPageGroupForumPost' ) {
					name = 'ClassPageGroupForum';
				} else if ( this.$route.name === 'ClassPageStudentForumPost' ) {
					name = 'ClassPageStudentForum';
				}
				
				this.$router.push({ 
					name: name, 
					params: params,
				});
			},
			isPostRepliesOpen(postId){
				return this.openPostReplies.includes(postId);
			},
			toggleOpenPostReplies(postId){
				if( this.isPostRepliesOpen(postId) ) {
					let index = this.openPostReplies.findIndex(post => post.POST_ID === postId);
					this.openPostReplies.splice(index, 1);
				} else {
					this.openPostReplies.push(postId);
				}
			},
			fetchForum(){
				const Forum = new ForumResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						forumId: this.$route.params.forumId,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					type: this.forumType,
				});

				Forum.get().then(() => {
					this.forum = Forum.getResponseData();
				});
			},
		fetchMenu(){
			const ClassPageMenu = new ClassPageMenuResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			ClassPageMenu.get().then(()=>{
				this.menu = ClassPageMenu.getResponseData();
			});
		},
		fetchDetails(){
			const ClassPageDetails = new ClassPageDetailsResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			ClassPageDetails.get().then(()=>{
				this.details = ClassPageDetails.getResponseData();
			});
		},
		fetchCourse(){
			const Course = new CoursesResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
			});

			Course.get().then(()=>{
				this.course = Course.getResponseData();
			});
		},
		fetchTopic( isRefresh = false ){
			const Topic = new TopicResource({
				routeParams: {
					courseSectionGuid: this.$route.params.courseSectionGUID,
					forumId: this.$route.params.forumId,
					topicId: this.$route.params.topicId,
				},
				query: {
					student_rid: this.selectedStudent.STUDENT_RID,
				},
				type: this.forumType,
			});
			Topic.get().then( () => {
				this.pageLoadedDate = moment().format("MM/DD/YY, h:mm:ss a");
				this.currentTopic = Topic.getResponseData();
				const forumId = this.currentTopic.FORUM_ID;
				const topicId = this.currentTopic.TOPIC_ID;
				const lastPostId = this.currentTopic.LAST_POST_ID;
				this.logActivity(forumId, topicId, lastPostId, this.forumType);
			});
		},

			/** Initialization */
			init () {
					this.fetchForum().then( () => {
							this.currentTopic.POSTS.forEach( post => { this.$set( post, "isShown", false ); } );
							this.reply.SUBJECT = "RE: " + this.currentTopic.TITLE;
					} );
			},
			openEditPostModal(post, subject){
				this.currentPost = post;
				this.reply = {
					POST_ID      : post.POST_ID,
					PARENT_ID    : post.PARENT_ID,
					SUBJECT      : !!subject ? "RE: " + subject : "RE: " + this.currentTopic.TITLE,
					REPLY        : post.REPLY,
					USER_NAME    : "",
					CREATED_DATE : "",
					REPLIES      : [],
					isShown      : false
				};
				this.showEditPostModal = true;
			},
			closeEditPostModal(){
				this.reply = {
					POST_ID      : null,
					PARENT_ID    : null,
					SUBJECT      : "RE: " + this.currentTopic.TITLE,
					REPLY        : "",
					USER_NAME    : "",
					CREATED_DATE : "",
					REPLIES      : [],
					isShown      : false
				};
				this.showEditPostModal = false;
			},
			updatePost(){
				const Post = new PostResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						forumId: this.$route.params.forumId,
						topicId: this.$route.params.topicId,
						postId: this.reply.POST_ID,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
					},
					data: {
						"title": this.reply.SUBJECT,
						"message": this.reply.REPLY,
					},
					type: this.forumType,
				});

				Post.put().then( () => {
					var newPost = Post.getResponseData();
					this.currentPost.COURSE_ID = newPost.COURSE_ID;
					this.currentPost.CREATED_BY = newPost.CREATED_BY;
					this.currentPost.CREATED_DATE = newPost.CREATED_DATE;
					this.currentPost.DISTRICT_ID = newPost.DISTRICT_ID;
					this.currentPost.FORUM_ID = newPost.FORUM_ID;
					this.currentPost.IS_DELETED_FLG = newPost.IS_DELETED_FLG;
					this.currentPost.MODIFIED_BY = newPost.MODIFIED_BY;
					this.currentPost.MODIFIED_DATE = newPost.MODIFIED_DATE;
					this.currentPost.PARENT_ID = newPost.PARENT_ID;
					this.currentPost.POSTER_PHOTO_URL = newPost.POSTER_PHOTO_URL;
					this.currentPost.POST_ID = newPost.POST_ID;
					this.currentPost.POST_LEVEL = newPost.POST_LEVEL;
					this.currentPost.REPLIES = newPost.REPLIES;
					this.currentPost.REPLY = newPost.REPLY;
					this.currentPost.SCHOOL_ID = newPost.SCHOOL_ID;
					this.currentPost.SCHOOL_YEAR = newPost.SCHOOL_YEAR;
					this.currentPost.SECTION_ID = newPost.SECTION_ID;
					this.currentPost.SORT_ORDER = newPost.SORT_ORDER;
					this.currentPost.SUBJECT = newPost.SUBJECT;
					this.currentPost.TEACHER_RID = newPost.TEACHER_RID;
					this.currentPost.TOPIC_ID = newPost.TOPIC_ID;
					this.currentPost.USER_NAME = newPost.USER_NAME;
					this.closeNewPostModal();
				});
				this.closeEditPostModal();
			},
			openNewPostModal(){
				this.reply.SUBJECT = `RE: ${this.currentTopic.TITLE}`;
				this.showNewPostModal = true;
			},
			closeNewPostModal(){
				this.reply = {
					POST_ID      : null,
					SUBJECT      : `RE: ${this.currentTopic.TITLE}`,
					REPLY        : "",
					USER_NAME    : "",
					CREATED_DATE : "",
					REPLIES      : [],
					isShown      : false
				};
				this.currentPost = {};
				this.showNewPostModal = false;
			},
			/**
			* Get total replies count of a post
			* @param { Object } post
			* @return { Integer }
			*/
			getPostsCount ( post ) {
					let total = 0;

					if ( !!post.REPLIES )
					{
							post.REPLIES.forEach( element => {
									total += this.getPostsCount( element );
							} );

							return total + post.REPLIES.length;
					}

					return total;
			},

			/**
			* Get all replies of a post
			* @param { Object } post
			* @return { Array }
			*/
			getPostsReplies ( post ) {
					let replies = [];

					if ( !!post.REPLIES )
					{
							post.REPLIES.forEach( element => {
									replies.push( this.getPostsReplies( element ) );
							} );

							replies.push( post.REPLIES );
							return replies.flat();
					}

					return replies.flat();
			},

			/**
			* Attach a reply into the correspondent post
			* @param { Integer } postId identifier
			*/
			postReply ( post ) {
				const Topic = new TopicResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						forumId: this.$route.params.forumId,
						topicId: this.$route.params.topicId,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						parent_post_id: post.POST_ID,
					},
					data: {
						"title": this.reply.SUBJECT,
						"message": this.reply.REPLY,
					},
					type: this.forumType,
				});

				Topic.post().then( () => {
					post.REPLIES.push(Topic.getResponseData());

					if( !this.isPostRepliesOpen(post.POST_ID) ) {
						this.toggleOpenPostReplies(post.POST_ID);
					}

					this.scrollToPost(Topic.getResponseData().POST_ID);
					this.closeNewPostModal();
				});				

				this.isReplying = -1; // To hide the box
			},

			/** Add new post to the topic */
			addPost () {
				const Topic = new TopicResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
						forumId: this.$route.params.forumId,
						topicId: this.$route.params.topicId,
					},
					query: {
						student_rid: this.selectedStudent.STUDENT_RID,
						parent_post_id: 0,
					},
					data: {
						"title": this.reply.SUBJECT,
						"message": this.reply.REPLY,
					},
					type: this.forumType,
				});

				Topic.post().then( () => {
					console.log(Topic.getResponseData())
					this.currentTopic.POSTS.push(Topic.getResponseData());
					this.scrollToPost(Topic.getResponseData().POST_ID);
					this.closeNewPostModal();
				});
			},
			logActivity(forumId, topicId, lastPostId, type){
				const folderType = {
					"group": "G",
					"course": "C",
					"student": "S"
				};
				const TopicLog = new ClassPageTopicLogResource({
					routeParams: {
						courseSectionGuid: this.$route.params.courseSectionGUID,
					},
					query: {
						forum_id: forumId,
						topic_id: topicId,
						last_post_id: lastPostId,
						student_rid: this.selectedStudent.STUDENT_RID,
						folder_type: folderType[type],
					}
				});

				TopicLog.post();
			},
			/**
			* Humanize the date
			* @param { String } date
			* @return { String }
			*/
			humanizeDate ( created ) {
					return moment.duration( moment( created ).diff( moment() ) ).humanize( true );
			}
	},
	
	created () {
		this.$store.commit('setUseHeader', false);
		this.fetchTopic();
		this.fetchMenu();
		this.fetchDetails();
		this.fetchCourse();
		this.fetchForum();
	}
};

/** Generate a UUID version 4 */
function uuidv4 () {
	return ( [ 1e7 ]+-1e3+-4e3+-8e3+-1e11 ).replace( /[018]/g, c =>
			( c ^ crypto.getRandomValues( new Uint8Array( 1 ) )[ 0 ] & 15 >> c / 4 ).toString( 16 )
	);
}
</script>
